import React from 'react'
import AdmProfitAndLoss from '../../components/AdminTabs/AdminProfitAndLoss/AdmProfitAndLoss'

const ProfitAndLoss = () => {
  return (
    <div>
      <AdmProfitAndLoss/>
    </div>
  )
}

export default ProfitAndLoss
